/**
 * The Team routes — v19 D1 (the dev-head view) and D2 (who does what), mounted through
 * the `routes.extra.ts` seam like every other feature.
 *
 * ⚠ BOTH PATHS ARE COPIED FROM THE NAV REGISTRY, NOT INVENTED. `domain/nav.ts`'s
 * `TEAM_NAV_SECTION` carries `path: 'team'` and `path: 'team/throughput'`; a route that
 * disagreed with either would give the sidebar a dead link (the `registers/routes.tsx`
 * lesson). `team-nav.test.ts` holds the two lists against each other.
 *
 * Both sit INSIDE `RequireCountry` + `AppShell` like every other country route, so the
 * pages can rely on `useCountryCode()` for the gate check and on a resolved session. The
 * DATA, though, is not the URL country's: both fetch bare cross-country routes scoped by
 * the token (`team-api.ts`), which is why the nav rows are `global: true`.
 *
 * NO PROVIDER LAYOUT: nothing on either screen mutates anything.
 */

import type { RouteObject } from 'react-router-dom';

import { TeamWorkloadPage } from './TeamWorkloadPage';
import { TeamThroughputPage } from './TeamThroughputPage';

export const teamDashboardRoutes: RouteObject[] = [
  { path: 'team', element: <TeamWorkloadPage /> },
  { path: 'team/throughput', element: <TeamThroughputPage /> },
];
